import { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { LoadingWrapper, ReactTable } from "../common";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchWithAuth, getCSRFToken } from "../auth";
import { statusMap } from "../common/helpers";
import { BooleanColumnFilter, BooleanFilterType } from "../common";


export const AssetProblems = (props) => {
  const [columnInfo, setColumnInfo] = useState([])
  const [problems, setProblems] = useState([])
  const [assetDetails, setAssetDetails] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [cannotReport, setCannotReport] = useState(true)
  const navigate = useNavigate();
  const { id } = useParams()

  async function getAssetProblems() {
    setLoaded(false)
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'assets/' + id + "/problems/", {
      headers: { 'X-CSRFToken': getCSRFToken() },
      credentials: 'include'
    })
    const respJson = await resp.json()
    // Handle both array response and paginated response
    const problemsData = Array.isArray(respJson) ? respJson : (respJson.results || [])
    problemsData.sort((problemA, problemB) => problemB.modifiedTime.localeCompare(problemA.modifiedTime))
    setProblems(problemsData)
    setLoaded(true)
    setCannotReport(problemsData.some((problem) => !problem.resolved))
  }

  async function getAssetDetails() {
    try {
      const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'assets/' + id + "/", {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
      })
      if (resp.ok) {
        const respJson = await resp.json()
        setAssetDetails(respJson)
      }
    } catch (error) {
      console.error('Failed to fetch asset details:', error)
    }
  }

  useEffect(() => {
    getAssetProblems()
    getAssetDetails()
  }, [])

  useEffect((isEdit) => {
    setColumnInfo([
      {
        Header: "Summary",
        accessor: "summary",
        Cell: (row) => {
          return <Link
            to={`/assets/${id}/problems/${row.row.original.id}`}>
            {statusMap[row.row.original.summary] ? statusMap[row.row.original.summary] : row.row.original.summary}
          </Link>
        }
      },
      {
        Header: "Assigned To",
        accessor: "createdByName",
        Cell: ({ cell, row }) => {
          return row.original.mechanicInfo?.name ? row.original.mechanicInfo.name : <div style={{ color: 'gray' }}>{cell.value}</div>
        }
      },
      {

        Header: "Last modified",
        accessor: "modifiedTime",
        Cell: (row) => {
          return row.row.original.modifiedTime.substring(0, 10)
        }
      },
      {
        Header: "Resolved",
        accessor: "resolved",
        Filter: row => BooleanColumnFilter(row, "Resolved", "Not resolved"),
        filter: BooleanFilterType,
        Cell: (row) => {
          return row.row.original.resolved ? <Icon className="check circle outline" color="green" size="large" /> : <Icon className="times circle outline" color="red" size="large" />
        }
      }
    ])
  }, [assetDetails])

  return (
    <div>
      <LoadingWrapper loading={!loaded} text="Loading problems">
        <ReactTable
          className="channel-table"
          data={problems}
          columns={columnInfo}
          hiddenColumns={['userId']}
        />
      </LoadingWrapper>
      {!cannotReport && <Button style={{ backgroundColor: "var(--delete)", color: "white" }} onClick={() => navigate(`/assets/${id}/problems/new`)}>Report problem</Button>}
      {cannotReport && <div><Icon className="exclamation circle" /> New problems cannot be reported until all problems are resolved.</div>}
    </div>
  );
}
